import React from "react";

import styled from "styled-components";

const padding = 20;
const bpDesktop = `900px`;

export const ProductHeader = styled.div`
  border-bottom: 1px solid var(--color-gray-medium);
  padding: 13px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;

  @media (min-width: ${bpDesktop}) {
    padding: 30px ${padding * 2}px;
  }
`;
export const ProductTitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  text-transform: capitalize;
  color: #393939;
`;
export const ProductClose = styled.button`
  color: #000;
  background-color: #fff;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  & svg {
    transition: transform 0.2s;
  }
  &:hover {
    background: transparent;
    & svg {
      transform: scale(1.1);
    }
  }
`;
export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="30"
      height="30"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 18L18 6M6 6l12 12"
      ></path>
    </svg>
  );
};
export const PlayIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path
          d="M55 28C55 41.8071 43.8071 53 30 53C16.1929 53 5 41.8071 5 28C5 14.1929 16.1929 3 30 3C43.8071 3 55 14.1929 55 28Z"
          fill="white"
        />
      </g>
      <path
        d="M37.4348 26.272C38.6607 27.0978 38.6607 28.9021 37.4348 29.7279L28.2473 35.9163C26.8635 36.8484 25.0001 35.8569 25.0001 34.1884L25.0001 21.8115C25.0001 20.143 26.8635 19.1515 28.2473 20.0836L37.4348 26.272Z"
        fill="#393939"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.145098 0 0 0 0 0.14902 0 0 0 0 0.117647 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const ProductDescription = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #797676;
  margin-bottom: 24px;
`;
export const ProductItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
`;
export const ProductTypeValue = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #2c272d;
  line-height: 1.6;

  ul,
  li {
    margin: 0;
    padding: 0;
    font: inherit !important;
    line-height: inherit !important;
  }
`;
export const ProductTypeName = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6;
  color: #747474;
  min-width: 153px;

  @media (min-width: ${bpDesktop}) {
    min-width: 191px;
  }
`;

export const ProductFooter = styled.div``;
export const ProductBack = styled.button`
  padding: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
`;
export const ProductVideo = styled.div`
  position: relative;
  z-index: 1;
  padding-top: 100%;
  width: 100%;
  background-color: #eeeeee;
  & video {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: cover;
  }
`;
export const ProductPlay = styled.button`
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    transition: transform 0.2s;
  }
  &:hover {
    background: transparent;
    & svg {
      transform: scale(1.1);
    }
  }
`;
